/**
 * Direct forms are transient (created per session, not persisted like cabinet forms).
 * Routes: /directForms/new/:formType, /directForms/:id/:section?
 */

const DIRECT_FORM_PATH_PREFIX = '/directForms';
const pathFromLocation = location => {
  if (!location || typeof location !== 'object') {
    return '';
  }
  const pathname = typeof location.pathname === 'string' ? location.pathname : '';
  if (pathname.startsWith(DIRECT_FORM_PATH_PREFIX)) {
    return pathname;
  }
  const hash = typeof location.hash === 'string' ? location.hash : '';
  if (!hash) {
    return pathname;
  }
  const hashPath = hash.startsWith('#') ? hash.slice(1) : hash;
  return hashPath.split('?')[0] || pathname;
};
const isDirectFormPath = location => {
  const path = pathFromLocation(location);
  return path === DIRECT_FORM_PATH_PREFIX || path.startsWith("".concat(DIRECT_FORM_PATH_PREFIX, "/"));
};
export default isDirectFormPath;